import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import { Container } from "@material-ui/core";

import OverviewFeatures from "../OverviewFeatures/OverviewFeatures";
import ProcessedProductMarketplaceFeatures from "./ProcessedProductMarketplaceFeatures";
import ProcessedProductMarketplaceBenefits from "./ProcessedProductMarketplaceBenefits";
import "./ProcessedProductMarketplace.css"


// Main component for onMarketplace
export default function ProcessedProductMarketplace() {
  // Overview Data: Describes the marketplace's primary function
  const data1 = [
    "Buy and Sell Service: onMarketplace facilitates the buying and selling of processed products, fostering efficient trade in agricultural commodities.",
  ];

  return (
    <>
      {/* Banner Section */}
      <UpdatesBanner
        className="processed-product-marketplace-bg"
        bannerTitle={["onMarketplace"]}
        bannerbodycopy="Traceability  | Organic"
      />

      {/* Overview Section */}
      <SolutionEcosystem title="Overview" type="PPM" />

      {/* Overview Features Section */}
      <Container>
        <OverviewFeatures data1={data1} />
      </Container>

      {/* Features & Benefits Section */}
      <ProcessedProductMarketplaceFeatures />
      <ProcessedProductMarketplaceBenefits />
    </>
  );
}
